import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex p-2 border-t" }
const _hoisted_2 = {
  key: 0,
  class: "ml-auto"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Selected for Sept. 18, 2021 ")
const _hoisted_4 = {
  key: 1,
  class: "flex ml-auto text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recommendation_card = _resolveComponent("recommendation-card")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("section", null, [
    (_ctx.selectedRecommendations.length)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
          class: "w-full p-2 mb-4 text-sm font-semibold text-center text-black rounded bg-highlight focus:outline-none",
          "data-testid": "email-recommendations-button"
        }, " Email recommendations (" + _toDisplayString(_ctx.selectedRecommendations.length) + ") ", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendationItems, (recommendationItem, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "mb-6 rounded bg-background",
        key: index
      }, [
        _createVNode(_component_recommendation_card, {
          recommendation: recommendationItem.recommendation
        }, null, 8, ["recommendation"]),
        _createVNode("div", _hoisted_1, [
          (recommendationItem.active)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_ctx.selectedRecommendations.length)
                  ? (_openBlock(), _createBlock(_component_button_component, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.handleRemove(recommendationItem.recommendation)),
                      small: true,
                      bgClass: "bg-highlight",
                      textClass: "text-black",
                      class: "w-full p-2 py-1 text-sm text-center text-black rounded focus:outline-none",
                      icon: _ctx.Icon.CHECK,
                      "data-testid": "recommendation-card-selector-remove-button"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["onClick", "icon"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", {
                  onClick: ($event: any) => (_ctx.handleDiscard(recommendationItem.recommendation)),
                  class: "text-gray-500 cursor-pointer",
                  "data-testid": "recommendation-card-selector-discard-button"
                }, " Discard ", 8, ["onClick"]),
                _createVNode("div", {
                  onClick: ($event: any) => (_ctx.handleSchedule(recommendationItem.recommendation)),
                  class: "ml-4 text-blue-500 cursor-pointer",
                  "data-testid": "recommendation-card-selector-schedule-button"
                }, " Select ", 8, ["onClick"])
              ]))
        ])
      ]))
    }), 128))
  ]))
}